export default class Invoice {
  constructor(data: {
    dateCreated: any;
    invoiceUrl: any;
    id: any;
    status: any;
    total: any;
  }) {
    this.setData(data);
  }

  setData(data: {
    dateCreated: any;
    invoiceUrl: any;
    id: any;
    status: any;
    total: any;
  }) {
    const { dateCreated, invoiceUrl, id, status, total } = data;

    if (dateCreated) {
      this.dateCreated = dateCreated;
    }

    if (invoiceUrl != null) {
      this.invoiceUrl = invoiceUrl;
    }

    if (id != null) {
      this.id = id;
    }

    if (status) {
      this.status = status;
    }

    if (total != null) {
      // 999 is actually 9.99
      this.total = total / 100;
    }
  }

  dateCreated: any = null;
  invoiceUrl = "";
  id = "";
  total = 0;
  status = "";
}
